import { createContext, type PropsWithChildren, use, useMemo } from "react";

import type { RawTypedNativeModules } from "./internal/NativeModulesTypes";

/** Hosts extend this registry with their application-specific bridge types. */
export interface BridgeRegistry extends RawTypedNativeModules {}

const BridgeContext = createContext<Partial<BridgeRegistry>>({});

export function useBridge(): Partial<BridgeRegistry> {
  return use(BridgeContext);
}

export function BridgeProvider({
  implementations,
  children,
}: PropsWithChildren<{
  implementations?: Partial<BridgeRegistry>;
}>) {
  const parent = useBridge();
  const bridges = useMemo(() => ({ ...parent, ...implementations }), [parent, implementations]);

  return <BridgeContext.Provider value={bridges}>{children}</BridgeContext.Provider>;
}
